import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 5px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const CloseButton = styled.button`
  background: purple;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  margin-top:120px;
  float: right;
`;

const Modal = ({ isOpen, onClose, assessment }) => {
  if (!isOpen) return null;

  return (
    <Overlay>
      <ModalContent>
        <CloseButton onClick={onClose}>Close</CloseButton>
        <h2>Assessment Details</h2>
        <p><strong>Name:</strong> {assessment.name}</p>
        <p><strong>Type:</strong> {assessment.type}</p>
        <p><strong>Vendor:</strong> {assessment.vendor}</p>
        <p><strong>Exam Code:</strong> {assessment.exam_code}</p>
        <p><strong>Exam Time:</strong> {assessment.exam_time}</p>
        <p><strong>Total Marks:</strong> {assessment.total_marks}</p>
        <p><strong>Price:</strong> ${assessment.price}</p>
        <p><strong>Start Date:</strong> {formatDate(assessment.start_date)}</p>
        <p><strong>End Date:</strong> {formatDate(assessment.end_date)}</p>
        <p><strong>Course Name:</strong> {assessment.course_name}</p>
        {/* Add more fields as necessary */}
      </ModalContent>
    </Overlay>
  );
};

const formatDate = (timestamp) => {
  const date = new Date(parseInt(timestamp));
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export default Modal;
